module.exports = __webpack_public_path__ + "img/value_icon2.b8a43886.png";